import { Component } from '@angular/core';

@Component({
  selector: 'note-to-hrsa',
  templateUrl: './note-to-hrsa.component.html',
  styleUrls: ['./note-to-hrsa.component.scss']
})
export class NoteToHrsaComponent {}
